// webapp/src/api/client.js
// Минимальный API-клиент для Mini App.
//
// Особенности:
// - Автоматически подставляет Telegram initData в заголовок x-telegram-init-data
// - Поддерживает JSON-запросы
// - Единый формат ошибок

function getInitData() {
  try {
    return window.Telegram?.WebApp?.initData || '';
  } catch (_) {
    return '';
  }
}

function buildHeaders(extra) {
  const headers = {
    'Content-Type': 'application/json',
    ...(extra || {})
  };

  const initData = getInitData();
  if (initData) {
    headers['x-telegram-init-data'] = initData;
  }

  return headers;
}

async function parseJsonSafe(res) {
  try {
    return await res.json();
  } catch (_) {
    return null;
  }
}

async function request(method, path, body, opts = {}) {
  const url = path.startsWith('http') ? path : path;

  const res = await fetch(url, {
    method,
    headers: buildHeaders(opts.headers),
    body: body === undefined ? undefined : JSON.stringify(body)
  });

  const data = await parseJsonSafe(res);

  if (!res.ok || (data && data.ok === false)) {
    const msg = (data && (data.error || data.message)) || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

export const api = {
  // Auth
  authWebApp: (initData) =>
    request('POST', '/api/auth/webapp', { initData }, { headers: initData ? { 'x-telegram-init-data': initData } : undefined }),

  // Health
  health: () => request('GET', '/api/health'),

  // Dashboard
  getDashboard: () => request('GET', '/api/dashboard'),

  // Stars
  getStars: () => request('GET', '/api/stars'),
  setStarChat: (level, chat_id) => request('PUT', `/api/stars/${level}`, { chat_id }),

  // Bindings
  getBindings: (search) => {
    const q = (search || '').trim();
    const url = q ? `/api/bindings?search=${encodeURIComponent(q)}` : '/api/bindings';
    return request('GET', url);
  },
  addBinding: (chat_id, star_level) => request('POST', '/api/bindings', { chat_id, star_level }),
  bulkBindings: (star_level, chat_ids) => request('POST', '/api/bindings/bulk', { star_level, chat_ids }),
  deleteBinding: (chatId) => request('DELETE', `/api/bindings/${encodeURIComponent(String(chatId))}`)
};

export default api;